// @ts-nocheck

import { cartGetCurrent, cartUpdate } from "@process-creative/slate-theme-tools";

// Use this if the elements you need to query are nested more than 1 level deep inside a slot
export const bindAssignedElements = (slotElement:HTMLSlotElement) => {
  // Step 1 - get the assigned elements from the slot
  const assignedElements = slotElement?.assignedElements();

  // Step two - 
  // The function takes a string and checks all the assigned 
  // elements for child elements which matches the selector
  // It will return the first found group of children
  return <E>(selector:string):E|null => assignedElements.reduce((match, currentEl) => {

    if (match) return match;
    const possibleMatchingElements = currentEl.querySelectorAll(selector);
    if (possibleMatchingElements.length) {
      return possibleMatchingElements.length > 1 ? possibleMatchingElements : possibleMatchingElements[0];
    } else {
      return null;
    }

  }, null);
}

export const removeBundleFromCart = async (bundleId:string) => {
  // get all products in cart with this bundle ID
  const { items } = cartGetCurrent();

  const bundleItemsToRemove = items.filter(line_item => {
    return line_item.properties?._bundle_id === bundleId;
  }).reduce((acc, line_item) => {
    return {
      ...acc,
      [line_item.key]: 0
    }
  }, {});

  await cartUpdate({
    updates: bundleItemsToRemove
  });
}
